var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import rotService from "@/core/services/rotService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Join_Fluxo_Inspecao_CampoActions } from "@/store/enums/rotEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Join_Fluxo_Inspecao_CampoModule = class Join_Fluxo_Inspecao_CampoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Join_Fluxo_Inspecao_CampoActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            rotService.getFile("Join_Fluxo_Inspecao_Campo/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Join_Fluxo_Inspecao_Campo.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Join_Fluxo_Inspecao_CampoActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            rotService.postFile("Join_Fluxo_Inspecao_Campo/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Join_Fluxo_Inspecao_CampoActions.POST_JOIN_FLUXO_INSPECAO_CAMPO](data) {
        return new Promise(resolve => {
            rotService.post("Join_Fluxo_Inspecao_Campo/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Join_Fluxo_Inspecao_CampoActions.PUT_JOIN_FLUXO_INSPECAO_CAMPO](data) {
        return new Promise(resolve => {
            rotService.put("Join_Fluxo_Inspecao_Campo/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Join_Fluxo_Inspecao_CampoActions.DELETE_JOIN_FLUXO_INSPECAO_CAMPO](data) {
        return new Promise(resolve => {
            rotService.delete("Join_Fluxo_Inspecao_Campo/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Join_Fluxo_Inspecao_CampoActions.DELETE_RANGE_JOIN_FLUXO_INSPECAO_CAMPO](data) {
        return new Promise(resolve => {
            rotService.delete("Join_Fluxo_Inspecao_Campo/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Join_Fluxo_Inspecao_CampoActions.FILTER_JOIN_FLUXO_INSPECAO_CAMPO](data) {
        return new Promise(resolve => {
            rotService.post("Join_Fluxo_Inspecao_Campo/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Join_Fluxo_Inspecao_CampoActions.GET_JOIN_FLUXO_INSPECAO_CAMPO]() {
        return new Promise(resolve => {
            rotService.get("Join_Fluxo_Inspecao_Campo/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Join_Fluxo_Inspecao_CampoActions.GETWITHDISABLED_JOIN_FLUXO_INSPECAO_CAMPO]() {
        return new Promise(resolve => {
            rotService.get("Join_Fluxo_Inspecao_Campo/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Join_Fluxo_Inspecao_CampoActions.GET_BY_ID_JOIN_FLUXO_INSPECAO_CAMPO](data) {
        return new Promise(resolve => {
            rotService.get("Join_Fluxo_Inspecao_Campo/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Join_Fluxo_Inspecao_CampoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Join_Fluxo_Inspecao_CampoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Join_Fluxo_Inspecao_CampoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Join_Fluxo_Inspecao_CampoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Join_Fluxo_Inspecao_CampoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Join_Fluxo_Inspecao_CampoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Join_Fluxo_Inspecao_CampoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Join_Fluxo_Inspecao_CampoModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Join_Fluxo_Inspecao_CampoModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Join_Fluxo_Inspecao_CampoModule.prototype, _k, null);
Join_Fluxo_Inspecao_CampoModule = __decorate([
    Module
], Join_Fluxo_Inspecao_CampoModule);
export default Join_Fluxo_Inspecao_CampoModule;
//# sourceMappingURL=Join_Fluxo_Inspecao_CampoModule.js.map